export default __webpack_public_path__ + "static/play-store-40a1b052f9c08464e9206af859a71377.png";